<template>
  <dl class="clearfix bg-blue-box p15 mt15">
    <job-preview-right-column
      :text-count-mode="textCountMode"
      :highlight-mode="highlightMode"
      comment-class="sub"
      :comment-highlights="commentHighlights"
      text-count-class="sub"
      :text-counts="textCounts"
      v-on="$listeners"
    />
    <dt :class="titleClass">
      【{{ title }}】
    </dt>
    <dd
      :id="targetId"
      class="pega-pre-wrap"
      v-text="value"
    />
  </dl>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/offer/base" as *;
</style>

<script>
import JobPreviewRightColumn from '@/components/molecules/JobPreviewRightColumn'

export default {
  components: {
    JobPreviewRightColumn
  },
  props: {
    commentHighlights: {
      type: Array,
      default: () => []
    },
    highlightMode: {
      type: Boolean,
      default: false
    },
    textCountMode: {
      type: Boolean,
      default: false
    },
    textCounts: {
      type: Array,
      default: () => []
    },
    targetId: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      required: true
    },
    titleClass: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      required: true
    }
  }
}
</script>
